import { FeatureDTO } from "./FeatureDTO";

export class VideoChatFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
